// Jquery
import $ from 'jquery';

// App components
import AdvancedFormApp from './AdvancedFormApp.js';
import Components from './components.js';
import LayoutThemeApp from './layout.js';
import Portlet from './portlet.js';
import RightBar from './rightbar.js';

export default class App {

	constructor() {
		this.$body = $('body');
		this.$window = $(window);
		this.advancedFormApp = new AdvancedFormApp();
		this.components = new Components();
		this.layoutThemeApp = new LayoutThemeApp();
		this.rightBar = new RightBar(this);
		this.portlet = new Portlet();
	}

	/**
	 * Activates the default theme
	 */
	activateDefaultSidebarTheme() {
		this.layoutThemeApp.activateDefaultSidebarTheme();
	}

	/**
	 * Activates the light theme
	 */
	activateLightSidebarTheme() {
		this.layoutThemeApp.activateLightSidebarTheme();
	}

	/**
	 * Activates the dark theme
	 */
	activateDarkSidebarTheme() {
		this.layoutThemeApp.activateDarkSidebarTheme();
	}

	/**
	 * Activates the condensed sidebar
	 */
	activateCondensedSidebar() {
		this.layoutThemeApp.activateCondensedSidebar();
	}

	/**
	 * Deactivates the condensed sidebar
	 */
	deactivateCondensedSidebar() {
		this.layoutThemeApp.deactivateCondensedSidebar();
	}

	/**
	 * Activates the scrollable sidebar
	 */
	activateScrollableSidebar() {
		this.layoutThemeApp.activateScrollableSidebar();
	}

	/**
	 * Deactivates the scrollable
	 */
	deactivateScrollableSidebar() {
		this.layoutThemeApp.deactivateScrollableSidebar();
	}

	/**
	 * Activates the boxed mode
	 */
	activateBoxed() {
		this.layoutThemeApp.activateBoxed();
	}

	/**
	 * Activate the fluid mode
	 */
	activateFluid() {
		this.layoutThemeApp.activateFluid();
	}

	/**
	 * Toggle the dark mode
	 */
	activateDarkMode() {
		this.layoutThemeApp.activateDarkMode();
	}

	/**
	 * Deactivate the dark mode
	 */
	deactivateDarkMode() {
		this.layoutThemeApp.deactivateDarkMode();
	}

	/**
	 * clear the saved layout related settings
	 */
	clearSavedConfig() {
		this.layoutThemeApp.clearSavedConfig();
	}

	/**
	 * Gets the layout config
	 */
	getLayoutConfig() {
		return this.layoutThemeApp.getConfig();
	}

	/**
	 * Reset the layout
	 */
	resetLayout(callback) {
		this.layoutThemeApp.reset(callback);
	}

	/**
	 * initializing
	 */
	init() {
		this.layoutThemeApp.init();
		this.rightBar.init();

		// showing the sidebar on load if user is visiting the page first time only
		const bodyConfig = this.$body.data('layoutConfig');
		if (window.sessionStorage && bodyConfig && Object.hasOwn(bodyConfig, 'showRightSidebarOnStart') && bodyConfig['showRightSidebarOnStart']) {
			const alreadyVisited = sessionStorage.getItem('_HYPER_VISITED_');
			if (!alreadyVisited) {
				this.rightBar.toggleRightSideBar();
				sessionStorage.setItem('_HYPER_VISITED_', 'true');
			}
		}

		// creating portlet
		this.portlet.init();
		this.advancedFormApp.init();
		this.components.init();
	}
}
